module.exports = __webpack_public_path__ + "img/lieshilingyuan.851e8d8b.jpg";